// @ts-nocheck

import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { basketImportItems } from '../../../../actions/basket';
import { send } from '../../../../actions/network';
import WinaLoader from '../../../../components/WinaLoader';
import useMergeProps from '../../../../hooks/useMergeProps';
import UrlShort from '../../../../managers/urlShort';
import { makeEntitiesBetslipsEntityStateByBetslipRefSelector } from '../../../../selectors/betslip.selector';
import { selectNetwork } from '../../../../selectors/network/networkPrimary.selector';
import { NetworkStatuses } from '../../../../types/network';
import { transformStringToBoolean } from '../../../../utils/string';
import { useBetslipOptionsContext } from '../../context/BetslipOptionsContext';
import { makeSelectBets } from '../../selectors/bets.selector';

import BetslipOptionsAddToBasketModal from './BetslipOptionsAddToBasketModal';
import { selectOutcomesByOutcomesIdsProps } from './BetslipOtpionsAddToBasketModal.selector';

type BetslipOptionsAddToBasketModalContainerProps = {
  betslipReference: string;
  shortUrlId?: string | null;
  onCloseModal: () => void;
};

const BetslipOptionsAddToBasketModalContainer = ({
  betslipReference,
  onCloseModal,
  shortUrlId,
}: BetslipOptionsAddToBasketModalContainerProps) => {
  const dispatch = useDispatch();
  const { uuid, betslipId } = useBetslipOptionsContext();
  const [options, setOptions] = useState(null);

  const networkStatus = useSelector(selectNetwork);

  const betslipSelector = useMemo(() => makeEntitiesBetslipsEntityStateByBetslipRefSelector(), []);
  const betslip = useSelector((state) => betslipSelector(state, { betslipReference }));

  const selectorProps = useMemo(() => ({ outcomeIds: betslip?.details?.map((d) => d?.outcomeId) }), [betslip?.details]);
  const outcomes = useSelector((state) => selectOutcomesByOutcomesIdsProps(state, selectorProps));
  const betsSelector = useMemo(() => makeSelectBets, []);
  const { bets } = useSelector((state) => betsSelector(state, { outcomes }));

  useEffect(() => {
    if (networkStatus === NetworkStatuses.CONNECTED) {
      dispatch(send({ getOneBetslip: { betslipReference } }));
    }
  }, [betslipReference, dispatch, betslip, networkStatus]);

  useEffect(() => {
    if (!betslip || !betslip.betslipId || !shortUrlId) {
      return;
    }

    UrlShort.getShortDatas(shortUrlId).then((data) => {
      setOptions(transformStringToBoolean(data));
    });
  }, [betslip, shortUrlId]);

  const onAddToBasketClick = useCallback(() => {
    dispatch(
      basketImportItems({
        sourceElementUuid: uuid,
        isRepeatBet: true,
        betslipReference,
        items: bets,
      }),
    );

    if (onCloseModal) {
      onCloseModal();
    }
  }, [bets, betslipReference, dispatch, onCloseModal, uuid]);

  const otherProps = useMemo(
    () => ({
      onAddToBasketClick,
      betslipReference,
      options,
      uuid,
      oddId: betslipId,
    }),
    [betslipId, betslipReference, onAddToBasketClick, options, uuid],
  );

  const enhancedProps = useMergeProps({ otherProps });

  return options ? <BetslipOptionsAddToBasketModal {...enhancedProps} /> : <WinaLoader />;
};

export default BetslipOptionsAddToBasketModalContainer;
